export const coursesCz = [
  {
    name: `Botanický seminář`,
    link: `http://botzool.sci.muni.cz/study/seminar_bot.pdf`
  },
  {
    name: `Bryologické praktikum`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6640`
  },
  {
    name: `Determinace mechorostů pro pokročilé`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9640`
  },
   {
    name: `Determinační praktikum krytosemenných rostlin`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8630`
  },
  {
    name: `Ekologie lesa`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8185`
  },
  {
    name: `Ekologie společenstev a makroekologie`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi6340`
  },
    {
    name: `Geobotanický projekt`,
	link: `https://is.muni.cz/predmet/sci/jaro2020/BI6662`
  },
  {
    name: `Geobotanický seminář`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/BI5659`
  },
  {
    name: `Chráněná území střední Evropy`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9980`
  },
  {
    name: `Introduction to Biostatistics in English`,
	link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6050`
  },
  {
    name: `Management ohrožených ekosystémů`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7113`
  },
   {
    name: `Plant Ecology Lab Meeting`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/BI9666`
  },
  {
    name: `Populační ekologie rostlin`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi5210`
  },
  {
    name: `Practical Analysis of Biological Data – Seminar`,
    link: `https://is.muni.cz/predmet/sci/Bi7550`
  },
  {
    name: `Právo a státní správa v ochraně přírody`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi7710`
  },
  {
    name: `Příroda ve čtvrtohorách`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi8300`
  },
   {
    name: `Terénní cvičení k systematické botanice`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi2130`
  },
  {
    name: `Terénní cvičení z botaniky`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi2160`
  },
  {
    name: `Terénní cvičení z geobotaniky`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6661`
  },
  {
    name: `Terénní exkurze k environmentálním problémům`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7111`
  },
  {
    name: `Úvod do studia ekologické a evoluční biologie`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi1000`
  },
  {
    name: `Vědecká práce v botanice a zoologii`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8705`
  },
  {
    name: `Vegetace a biotopy ČR`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6540`
  },
  {
    name: `Vegetace a biotopy Evropy`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9420`
  },
  {
    name: `Zahraniční botanická exkurze`,
    link: `https://is.muni.cz/course/sci/jaro2020/BI6691?lang=cs`
  },
  {
    name: `Základní metody terénní botaniky`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6450`
  },
  {
    name: `Zpracování dat v ekologii společenstev`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7540`
  },
  {
    name: `Zpracování základních botanických dat`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6549`
  },
  
];

export const coursesEn = [
  {
    name: `Botany seminar`,
    link: `http://botzool.sci.muni.cz/study/seminar_bot.pdf`
  },
  {
    name: `Bryological practice`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6640?lang=en`
  },
  {
    name: `Bryophytes determination for advanced`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9640?lang=en`
  },
   {
    name: `Angiosperm identification course`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8630?lang=en`
  },
  {
    name: `Forest ecology`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8185?lang=en`
  },
  {
    name: `Community ecology and macroecology`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi6340?lang=en`
  },
   {
    name: `Geobotany project`,
	link: `https://is.muni.cz/predmet/sci/jaro2020/BI6662?lang=en`
  },
  {
    name: `Geobotany seminar `,
	link: `https://is.muni.cz/predmet/sci/podzim2019/BI5659?lang=en`
  },
  {
    name: `Protected areas of Central Europe`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9980?lang=en`
  },
  {
    name: `Introduction to biostatistics in English`,
	link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6050?lang=en`
  },
  {
    name: `Management of endangered ecosystems`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7113?lang=en`
  },
   {
    name: `Plant ecology lab meeting`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/BI9666?lang=en`
  },
  {
    name: `Plant population ecology`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi5210?lang=en`
  },
    {
    name: `Practical Analysis of Biological Data – Seminar`,
    link: `https://is.muni.cz/predmet/sci/Bi7550?lang=en`
  },
  {
    name: `Nature conservation and environmental legislation`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi7710?lang=en`
  },
  {
    name: `Quaternary environments`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi8300?lang=en`
  },
   {
    name: `Field course of systematic botany`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi2130?lang=en`
  },
  {
    name: `Field botanical excursion`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi2160?lang=en`
  },
  {
    name: `Field course of geobotany`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6661?lang=en`
  },
  {
    name: `Field excursion on environmental problems`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7111?lang=en`
  },
  {
    name: `Introduction to study of ecological and evolutionary biology`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi1000?lang=en`
  },
  {
    name: `Scientific work in botany and zoology`,
    link: `https://is.muni.cz/predmet/sci/podzim2019/Bi8705?lang=en`
  },
  {
    name: `Vegetation and habitats of the Czech Republic`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6540?lang=en`
  },
  {
    name: `Vegetation and habitats of Europe`,
	link: `https://is.muni.cz/predmet/sci/podzim2019/Bi9420?lang=en`
  },
  {
    name: `Botanical excursion abroad`,
    link: `https://is.muni.cz/course/sci/jaro2020/BI6691?lang=en`
  },
  {
    name: `Basic methods of field botany`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6450?lang=en`
  },
  {
    name: `Data analysis in community ecology`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi7540?lang=en`
  },
  {
    name: `Processing basic botanical data`,
    link: `https://is.muni.cz/predmet/sci/jaro2020/Bi6549?lang=en`
  }
];
